/* eslint-disable prefer-promise-reject-errors */
import { Rule } from 'antd/lib/form';
import { validateVinNumber, validatePromocode } from '@/api/logicStars';

export const VIN_MASK = '*****************';

export const PROMOCODE_MASK = (value: string) => {
  return /^[A-Za-z0-9]*$/.test(value);
};

export const CUSTOM_RULES: Record<string, Rule> = {
  vin: {
    validator: async (_, vin) => {
      try {
        if (!vin) return await Promise.resolve();
        if (vin.length < 6) return await Promise.resolve();
        const { data } = await validateVinNumber({ vin });
        if (data.ErrorInfo) {
          return await Promise.reject({
            errorMessage: `${data.ErrorInfo}`.toLowerCase(),
          });
        }
        return await Promise.resolve();
      } catch (e: any) {
        const errorMessage = e?.errorMessage ?? 'не удалось выполнить проверку';
        return Promise.reject(new Error(errorMessage));
      }
    },
  },
  promocode: {
    validator: async (_, promocode) => {
      try {
        if (!promocode) return await Promise.resolve();
        if (promocode.length < 5) return await Promise.resolve();
        if (promocode.length > 50) return await Promise.resolve();
        const { data } = await validatePromocode({ promocode });
        if (data.ErrorInfo) {
          return await Promise.reject({
            errorMessage: `${data.ErrorInfo}`.toLowerCase(),
          });
        }
        return await Promise.resolve();
      } catch (e: any) {
        const errorMessage = e?.errorMessage ?? 'не удалось выполнить проверку';
        return Promise.reject(new Error(errorMessage));
      }
    },
  },
} as const;
